module.exports = __webpack_public_path__ + "img/earth-americas.097053c1.svg";